<template>
  <div
    id="vapp"
    class="vapp"
    v-cloak
    v-on:drop.prevent="handleDesktopDrop"
    v-on:dragover.prevent="handleDragOver"
    v-on:dragenter.prevent="handleDragEnter"
    v-on:dragleave.prevent="handleDragLeave"
  >
    <div class="apphead">
      <!-- Top Navigation Menu -->
      <div class="topnav">
        <a
          class="applogo"
          v-bind:class="{ error: errorStatus }"
          :title="applicationName"
          >{{ userMessage }} [{{ user.name }}]</a
        >
        <!--                <h2 class="wrapped message" v-show="!errorStatus">{{ userMessage }}</h2>
                <h2 class="wrapped error" v-show="errorStatus">{{ userMessage }}</h2> -->
        <!-- Navigation links (hidden by default) -->
        <div id="menuEntries" v-if="showMenu">
          <a v-on:click="onShowLog"
            ><i class="fa fa-terminal" />&nbsp; {{ showLogMsg() }}</a
          >
          <a v-on:click="onChangePassword"
            ><i class="fa fa-key" />&nbsp; {{ $t("menu.CHANGE_PWD") }}</a
          >
          <a v-on:click="onLogout"
            ><i class="fa fa-sign-out" />&nbsp; {{ $t("menu.LOGOUT") }}</a
          >
        </div>
        <!-- "Hamburger menu" / "Bar icon" to toggle the navigation links -->
        <a
          href="javascript:void(0);"
          class="icon"
          v-on:click="onHamburgerClick"
        >
          <i class="fa fa-bars"></i>
        </a>
        <a
          href="#"
          class="icon"
          v-bind:class="[isOnline() ? 'online' : 'offline']"
          :title="isOnlineMsg()"
        >
          <i class="fa fa-signal"></i>
        </a>
      </div>
    </div>
    <div class="appbody">
      <div class="appbodybody">
        <div class="wrapper appbodybodywrapper">
          <div class="projectscontainer bluerectcontainer">
            <div class="appbodytoolbar">
              <div class="hwrapper">
                <h2 class="wrapped">{{ $t("prj.TITLE") }}</h2>
                <buttonstoolbar
                  v-bind:buttons="projectButtons"
                ></buttonstoolbar>
              </div>
            </div>
            <multiselect
              v-bind:columns="['name', 'lastSentDate', 'numRecsToBeSent']"
              v-bind:items="projects"
              v-bind:tooltip="onProjectTooltip"
              v-on:item-selected="onProjectSelected"
            >
            </multiselect>
          </div>
          <div class="filescontainer bluerectcontainer">
            <div class="largetoolbar">
              <div class="hwrapper">
                <h2 class="wrapped">{{ $t("file.TITLE") }}</h2>
                <buttonstoolbar
                  v-bind:buttons="fileButtons"
                  v-on:toolbar-drop="onFileToolbarDrop"
                ></buttonstoolbar>
              </div>
            </div>
            <multiselect
              ref="files"
              v-bind:options="{ select: 'multi', canDrag: true }"
              v-bind:items="filesArray"
              v-bind:tooltip="onFileTooltip"
              v-on:item-selected="onFileSelected"
              v-on:item-drag-start="onFileDragStart"
              v-on:item-drag-end="onFileDragEnd"
            ></multiselect>
          </div>
          <div class="filepreviewcontainer bluerectcontainer">
            <div class="appbodytoolbar">
              <div class="hwrapper">
                <h2 class="wrapped">
                  {{ $t("preview.TITLE") }}
                </h2>
              </div>
            </div>
            <preview v-bind:file="previewFile" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLog" class="apptail">
      <div class="appbodytoolbar">
        <div class="configscontainer wrapper">
          <h2 class="wrapped">{{ $t("log.TITLE") }}</h2>
        </div>
      </div>
      <div class="log bluerect" v-html="fullLog"></div>
    </div>
    <editor
      ref="edt"
      v-bind:editFileData="editFileData"
      v-on:onSave="onSaveFileData"
    />
    <prjeditor
      ref="prjedt"
      v-bind:editProjectData="editProjectData"
      v-on:onSave="onSaveProjectData"
    />
    <dropper
      ref="drp"
      v-bind:selectedProject="getSelectedProject()"
      v-on:onDrop="onDrop"
      v-on:onDropComplete="onDropComplete"
    />
    <div id="utility" style="display: none"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import pdfjsLib from "pdfjs-dist";
import moment from "moment";
import serverConnect from "../services/serverConnect";
import apiClient from "../services/apiClient";

import multiselect from "./multiselect.vue";
import buttonstoolbar from "./buttonstoolbar.vue";
import preview from "./preview.vue";
import editor from "./editor.vue";
import prjeditor from "./prjeditor.vue";
import dropper from "./dropper.vue";
import comms from "../services/comms";
import config from "../config";
import profileService from "../services/profileService";
import objectsUtil from "../services/objectsUtil";
import eventBus from "../services/eventBus";

import {
  Project,
  w2dImage,
  ProjectOptions,
  w2dArticle,
  w2dPdf,
  w2dAny
} from "../model/w2dclasses";
import { FileRow, ProjectRow } from "../view/w2dviewclasses";
import { fetchWrapper } from "../services/fetchWrapper";
//require('vue-dropdownmenu/dist/vue-dropdown.css');
// in ES6 modules
import dropdown from "./dropdown.vue";

export default {
  name: "w2d",
  components: {
    multiselect,
    buttonstoolbar,
    preview,
    editor,
    prjeditor,
    dropper,
    dropdown
  },
  props: {},
  computed: {
    ...mapGetters({
      config: "configuration/activeConfiguration",
      activeConfig: "configuration/active",
      projects: "projects/list",
      selectedProject: "projects/selectedProject",
      getProjectById: "projects/projectById",
      socketId: "application/socketId"
    })
  },
  data: function () {
    return {
      user: {},
      applicationName: `adm-uploader - ${config.appVersion}`,
      currentUploadedTxtFiles: 0,
      fontFamily: "",
      aFontFamily: [
        { value: "One", text: "One" },
        { value: "Two", text: "Two" },
        { value: "Three", text: "three" },
        { value: "SimHei", text: "黑体" },
        { value: "SimSun", text: "宋体" }
      ],

      previewFile: {
        type: "",
        imgsrc: "",
        headline: "",
        lead: "",
        body: "",
        dest: "",
        contentId: undefined,
        published: undefined
      },
      editFileData: {
        project: undefined,
        _id: "",
        type: "",
        imgsrc: "",
        headline: "",
        lead: "",
        body: "",
        dest: undefined
      },
      editProjectData: new Project("", ""),
      enterTarget: null,
      droppedImg: "",
      configHistory: "",
      currentArea: "",
      dropArea: null,
      socket: null,
      timeout: 0,
      dropTimeout: 0,
      fullLog: "",
      defaultUserMessage: "dm.desk uploader",
      userMessage: this.defaultUserMessage,
      validExtensions: ["docx", "doc", "rtf", "odt", "txt"],
      errorStatus: false,
      showLog: false,
      showMenu: false,
      filesArray: [],
      scrapedurlsArray: [],
      projectButtons: [
        {
          call: this.addProjectBtnOnClick,
          label: "prj.BUTTON_ADD",
          icon: "fa-plus-circle"
        },
        {
          call: this.editProjectBtnOnClick,
          label: "prj.BUTTON_MODIFY",
          icon: "fa-edit"
        },
        {
          call: this.onclickDeleteProject,
          label: "prj.BUTTON_REMOVE",
          icon: "fa-minus-circle"
        },
        {
          call: this.onclickUploadProject,
          label: "prj.BUTTON_SEND",
          icon: "fa-paper-plane"
        }
      ],
      fileButtons: [
        {
          label: "file.BUTTON_ADD",
          call: this.newFile,
          exclusive: false,
          icon: "fa-plus"
        },
        {
          label: "file.BUTTON_MODIFY",
          call: this.editFile,
          exclusive: false,
          icon: "fa-edit"
        },
        {
          label: "file.BUTTON_REMOVE",
          call: this.onclickDeleteFiles,
          exclusive: false,
          title: "Delete file (shift deletes all)",
          icon: "fa-minus"
        },
        {
          call: this.onclickUploadSelected,
          label: "file.BUTTON_SEND",
          icon: "fa-paper-plane-o",
          isVisible: config.ui.showSingleContentSendBtn
        },
        {
          call: this.onclickUploadNewFile,
          label: "file.BUTTON_UPLOAD",
          icon: "fa-upload"
        }
      ]
    };
  },
  methods: {
    ...mapActions(["clearUserState", "setToken"]),
    ...mapActions({
      prjSelect: "projects/setSelected",
      prjAdd: "projects/add",
      prjRemove: "projects/del",
      prjChange: "projects/change",
      prjClear: "projects/clear"
    }),
    onProjectTooltip(prj, colIdx) {
      if (colIdx < 2) {
        const tt_sent_suffix = prj.numRecsToBeSent > 1 ? "_PL" : "";
        const tt_alreadySent_suffix = prj.numRecsSent > 1 ? "_PL" : "";
        const tt_sent = this.$t("prj.TOOLTIP_SENT" + tt_sent_suffix);
        const tt_alreadySent = this.$t(
          "prj.TOOLTIP_ALREADY_SENT" + tt_alreadySent_suffix
        );
        let lastSend = "";
        if (prj.lastSend > 0) {
          lastSend = `<li>${this.$t("prj.TOOLTIP_LASTSEND")} ${moment(
            prj.lastSend
          ).fromNow()} <span="tooltip-lastsend">(${moment(prj.lastSend).format(
            "YYYY-MM-DD hh:mm:ss"
          )})</span></li>`;
        }
        const created = `<li>${this.$t("prj.TOOLTIP_CREATED")} ${moment(
          prj.project.date
        ).format("YYYY-MM-DD hh:mm:ss")}</li>`;
        let toBeSent = "";
        if (prj.numRecsToBeSent > 0) {
          toBeSent = `<li>${prj.numRecsToBeSent} ${tt_sent}</li>`;
        }
        let alreadySent = "";
        if (prj.numRecsSent > 0) {
          alreadySent = `<li>${prj.numRecsSent} ${tt_alreadySent}</li>`;
        }
        return `
      <div class="mytooltip">
        <b>${prj.name}</b>
        <ul>
          ${toBeSent}
          ${alreadySent}
          ${created}
          ${lastSend}
        </ul>
      </div>`;
      }
      return undefined;
    },

    onFileTooltip(file, colIdx) {
      if (file.isError) {
        return `
      <div class="mytooltip">
        <b>${file.name}</b>
        <p>${file.isError}</p>
      </div>`;
      }
      return undefined;
    },

    onShowLog() {
      this.showLog = !this.showLog;
      this.setCookie("showLog", this.showLog, 365);
      this.onHamburgerClick();
    },

    onLogout() {
      this.logout();
    },

    onChangePassword() {
      this.$router.push("/changePwd").catch(() => {
        this.timedUserMessage(this.$t("message.cannotChangePwd"));
      });
    },

    logout() {
      this.clearUserState();
      this.$emit("loggedOut");
      // reload the current view (an alternative solution would be window.location.reload(true)
      // but it forces reloading of the assets).
      //this.$router.go(0);
      this.$router.push("/login");
    },

    /* Toggle between showing and hiding the navigation menu links when the user clicks on the hamburger menu / bar icon */
    onHamburgerClick() {
      this.showMenu = !this.showMenu;
    },
    getFirstSelectedFile() {
      for (var i = 0; i < this.filesArray.length; i++) {
        if (this.filesArray[i].isSelected) {
          return this.filesArray[i];
        }
      }
      return undefined;
    }, // getFirstSelectedFile

    getFilebyName(theName) {
      for (var i = 0; i < this.filesArray.length; i++) {
        if (this.filesArray[i].name == theName) {
          return this.filesArray[i];
        }
      }
      return undefined;
    }, // getFilebyName

    getFileById(id) {
      const result = this.filesArray.filter(f => f.id === id);
      if (result.length > 0) {
        return result[0];
      }
      return undefined;
    }, // getFileById

    replaceSubstitutions(html) {
      let replacements = [
        "&lt;no1&gt;inizio:LREBOR&lt;no&gt;",
        "&lt;no1&gt;fine:LREBOR&lt;no&gt;",
        "&gt;",
        "&lt;"
      ];
      let map = {
        "&lt;no1&gt;inizio:LREBOR&lt;no&gt;": "",
        "&lt;no1&gt;fine:LREBOR&lt;no&gt;": "",
        "&gt;": "»",
        "&lt;": "«"
      };
      var s = html;
      for (var idx = 0; idx < replacements.length; idx++) {
        var k = replacements[idx];
        s = s.replace(new RegExp(k, "g"), map[k] || "");
      }
      return s;
    },

    /**
     * onSaveFileData
     *
     * No parameters, called back when the main editor is closed.
     * editFileData is the global object that contains the data being edited
     */
    onSaveFileData() {
      if (this.editFileData._id == undefined) {
        this.editFileData.project = this.getSelectedProject().id;
        this.editFileData.area = this.getAreaName(this.currentArea);
        if (this.editFileData.body) {
          this.editFileData.body = this.replaceSubstitutions(
            this.editFileData.body
          );
        }
        this.addArticleToProject(this.editFileData);
      } else {
        const theFile = this.getFileById(this.editFileData._id);
        if (theFile) {
          theFile.isError = undefined;
        }
        this.saveFileExtendedInfo(this.editFileData);
      }

      this.setupPreviewData(this.editFileData);
      this.updateCurrentProjectCount();
    },

    async editFile() {
      var file = this.getFirstSelectedFile();
      this.editFileData = await this.getFileExtendedInfo(file);
      if (file.dest !== undefined) {
        this.editFileData.dest = file.dest;
      } else if (file.file && file.file.dest !== undefined) {
        this.editFileData.dest = file.file.dest;
      }
      if (this.editFileData.dest === undefined) {
        this.editFileData.dest =
          this.getProfileService().getDefaultDestination();
      }
      if (this.editFileData !== undefined) {
        this.editFileData.requestUrl = this.buildRestUrl(
          this.editFileData.requestUrl
        );
        return this.$refs.edt.editFile();
      } else {
        throw new Error("missing file");
      }
    },

    async newFile() {
      let txtCount = 0;
      this.filesArray
        .filter(f => f && f.file && f.file.type === "url")
        .map(() => (txtCount += 1));
      if (txtCount > 0) {
        const msg = this.$t("message.tooManyArticles");
        this.logError(msg);
        return;
      }
      const curProject = this.getSelectedProject();
      this.editFileData._id = undefined;
      this.editFileData.type = "url";
      this.editFileData.name = "";
      this.editFileData.headline = "";
      this.editFileData.lead = "";
      this.editFileData.body = "";
      this.editFileData.imglink = "";
      this.editFileData.doclink = "";
      this.editFileData.requestUrl = "";
      this.editFileData.project = "";
      this.editFileData.parentproject = "";
      if (curProject && curProject.name) {
        this.editFileData.name = curProject.name;
      }
      if (curProject && curProject.project && curProject.project.dest) {
        this.editFileData.dest = curProject.project.dest;
      } else {
        this.editFileData.dest =
          this.getProfileService().getDefaultDestination();
      }
      console.log("this.editFileData", objectsUtil.plain(this.editFileData));
      return this.$refs.edt.editFile();
    },

    beforeOpen(event) {
      this.editFileData.headline = event.params.headline;
      this.editFileData.body = event.params.body;
    },
    /**
     * onSaveProjectData
     *
     * No parameters, called back when the project editor is closed.
     * editProjectData is the global object that contains the data being edited
     */
    onSaveProjectData() {
      if (this.editProjectData._id == undefined) {
        this.createProject(this.editProjectData);
      } else {
        this.saveProject(this.editProjectData);
      }
    },
    setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },

    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    buildRestUrl(url) {
      //var cl = window.location;
      var result = config.baseUrl + url;
      return result;
      //return url;
    },

    reloadConfig() {
      // var div = document.getElementById('configs');
      // div.innerHTML = "";
      this.socket.emit("getconfig", {
        my: "data",
        url: window.location.href
      });
    }, // reloadConfig

    getAreaId(theAreaName) {
      return "area" + theAreaName;
    }, // getAreaId

    getAreaName() {
      return "Incoming";
    }, // getAreaName

    getUserName() {
      return this.user.name;
    }, // getUserName

    async deleteFile(theFileId) {
      let url = this.buildRestUrl("/file/" + theFileId);

      try {
        await fetchWrapper(url, {
          method: "DELETE"
        });
        this.filesArray = this.filesArray.filter(tmp => tmp.id != theFileId);
        this.onFileSelected();
        this.updateCurrentProjectCount();
      } catch (error) {
        this.logError("Could not delete file. " + error.toString());
      }
    }, // deleteFile

    onclickDeleteFiles() {
      const shift = event.shiftKey;
      const alt = event.altKey;

      const ids = [];
      for (let i = 0; i < this.filesArray.length; i++) {
        const f = this.filesArray[i];
        if (f.isSelected || shift) {
          // prevent file deletion if the file has been already submitted to desk
          // unless the user is pressing the alt key (but not the shift key, the
          // shift key will cause all the other files to be deleted).
          if (!f.file.contentId || (alt && !shift)) {
            ids.push(f.id);
          }
        }
      }
      for (let i = 0; i < ids.length; i++) {
        this.deleteFile(ids[i]);
      }
    }, // onclickDeleteFiles

    async testUrlIsImage(theUrl) {
      var response = await fetchWrapper(theUrl, {
        method: "HEAD",
        Accept: "application/json",
        "Content-Type": "application/json"
      });

      //var myJson = await response.json();
      if (response.ok) {
        var header = response.headers.get("Content-Type");

        if (header.indexOf("image") != -1) {
          return true;
        }
      }
      return false;
    },

    clearDropPreview() {
      var preview = document.getElementById("preview");
      if (preview) {
        preview.innerHTML = "";
      }
    }, // clearDropPreview

    async addArticleToProject(theFile) {
      let url = this.buildRestUrl("/articletoproject");
      try {
        let reqdata = {
          file: theFile
        };
        console.log("addArticleToProject", objectsUtil.plain(theFile));
        var response = await fetchWrapper(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          data: reqdata
        });
        var data = response.data;

        // when adding a file to the view we should have all the fields.
        const newFile = objectsUtil.plain(theFile);
        newFile._id = data._id;
        newFile.name = data.name;
        newFile.type = newFile.type || "url";
        this.addNewFile(newFile);
        this.clearDropPreview();
      } catch (error) {
        this.logError("Element could not be added. " + error.toString()); // Error. Inform the user
        this.clearDropPreview();
      }
    }, // addArticleToProject

    /**
     * Add an url to a project, scraping content from the pointed url
     * @constructor
     * @param {string} theUrl - Full url of the page to scrape.
     * @param {string} theProject - The project.
     */
    async addUrlToProject(theUrl, theProject, options) {
      options = options || {};
      const url = this.buildRestUrl("/urltoproject");
      const urlData = new w2dArticle(
        theUrl,
        theProject.id,
        this.getAreaName(this.currentArea)
      );
      const projectDest = theProject.project
        ? theProject.project.dest
        : theProject.dest;
      urlData.dest =
        projectDest || this.getProfileService().getDefaultDestination();

      console.log("addUrlToProject", objectsUtil.plain(urlData));
      try {
        var response = await fetchWrapper(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            uploadToDesk: false,
            storeInProject: true,
            config: options.config,
            urlData: urlData
          }
        });

        this.addNewFile(response.data);
        this.clearDropPreview();
      } catch (error) {
        this.logError("Element could not be added. " + error.toString()); // Error. Inform the user
        this.clearDropPreview();
      }
    }, // addUrlToProject

    onProjectSelected(theProject) {
      return this.prjSelect(theProject.id).then(() => {
        return this.reloadFiles(
          theProject.id,
          this.getAreaName(this.currentArea)
        );
      });
    }, // onProjectSelected

    async countFiles(theProjectId) {
      let url = "/filescount/" + theProjectId;
      url = this.buildRestUrl(url);
      //var params = { parentProject: theProjectId };
      var response = await fetchWrapper(url, {
        method: "GET"
      });
      return response.data;
    },

    async reloadProjects() {
      try {
        var self = this;
        var username = this.getUserName();
        this.prjClear();
        this.clearFiles();
        let url = "/project";

        if (username != "") {
          url += "/" + username;
        }

        url = this.buildRestUrl(url);
        const response = await fetchWrapper(url, { method: "GET" });
        const projects = response.data;
        let project;
        for (project of projects) {
          if (!project.name) {
            project.name = "(empty)";
          }
          console.log("project: ", objectsUtil.plain(project));
          const numrecs = await self.countFiles(project._id);
          let projectRow = new ProjectRow(project, this.prjSelect);
          this.updateProjectCount(projectRow, numrecs);
          this.prjAdd(projectRow);
        }
      } catch (error) {
        this.logError("Could not load projects. " + error.toString()); // Error. Inform the user
      }
    }, // reloadProjects

    async updateCurrentProjectCount() {
      var projectRow = this.getSelectedProject();
      var numrecs = await this.countFiles(projectRow.id);
      this.updateProjectCount(projectRow, numrecs);
    },

    updateProjectCount(project, numrecs) {
      const incoming = numrecs.Incoming.total;
      const sent = numrecs.Sent.total;
      const lastSend = Math.max(
        numrecs.Incoming.last || 0,
        numrecs.Sent.last || 0
      );
      project.numRecsIncoming = incoming;
      project.numRecsSent = sent;
      project.numRecsToBeSent = incoming - sent;
      project.lastSend = lastSend;
      if (lastSend > 0) {
        project.lastSentDate = moment(lastSend).format("YYYY-MM-DD hh:mm:ss");
      }
      project.isSent =
        project.numRecsToBeSent <= 0 && project.numRecsSent > 0 && lastSend > 0;
      project.isWarn = (project.numRecsToBeSent > 0) & (lastSend > 0);
    },

    //****************** FILES MANAGEMENT ******************

    /**
     * addFile
     *
     * Add a file created in the UI to the list, updates the project count
     *
     * theFile - string
     */
    addNewFile(theFile) {
      this.addFile(theFile);
      this.updateCurrentProjectCount();
    },

    addFile(theFile) {
      var fileRow = new FileRow(theFile);
      this.filesArray.push(fileRow);

      // sort files by name and if they match sort by id.
      this.filesArray.sort((a, b) => {
        const result = (a.name || "").localeCompare(b.name || "");
        if (result === 0) {
          return (a.id || "").localeCompare(b.id || "");
        }
        return result;
      });

      this.onFileSelected(fileRow);
    }, // addFile

    clearFiles() {
      this.filesArray = [];
      this.clearFilePreview();
    }, // clearFiles

    async reloadFiles(theProjectId, theAreaName) {
      this.clearFiles();
      if (theAreaName === undefined) {
        theAreaName = "incoming";
      }

      let url = this.buildRestUrl("/projectfiles/" + theProjectId);

      try {
        var response = await fetchWrapper(url, { method: "GET" });
        var data = response.data;
        data.forEach(file => {
          if (!file.name || file.name.trim().length === 0) {
            file.name = `${file._id} (${file.type})`;
          }
          // Log each movie's title
          if (file.area == theAreaName) {
            this.addFile(file);
          }
          if (!file.area) {
            file.name = file.name + " (error: no area)";
            this.addFile(file);
          }
        });
      } catch (error) {
        this.logError("Could not get the list of files. " + error.toString());
      }
    }, // reloadFiles

    getSelectedConfig() {
      const c = this.config;
      return {
        id: c.text,
        name: c.text
      };
    }, // getSelectedConfig

    onConfigSelected(theConfig) {
      var cookieStr = theConfig.id;
      this.setCookie("default", cookieStr, 365);
    }, // onConfigSelected

    selectProject(theProject) {
      if (theProject.isSelected) {
        return;
      }
      this.prjSelect(theProject.id).then(() => {
        this.reloadFiles(theProject.id, this.getAreaName(this.currentArea));
      });
    }, // selectConfig

    getSelectedProject() {
      const prj = this.selectedProject;
      return prj;
    }, // getSelectedProject

    // function selectUrl() {
    //     // "click" could happen on an element that is contained in the main <LI>
    //     // so we look for the parent element
    //     // During the element creation we added the id only to the <LI> element
    //     event.preventDefault();
    //     event.stopPropagation();
    //     document.getSelection().removeAllRanges();
    //     var element = event.srcElement;
    //     while (element.id == "") {
    //         element = element.parentElement;
    //     }
    //     var shift = event.shiftKey;

    //     if (shift) {
    //         if (element.classList.contains("savedurlsselected")) {
    //             element.classList.remove("savedurlsselected");
    //         } else {
    //         element.classList.add("savedurlsselected");
    //         }
    //     } else {
    //         // Since id's are always set on li, we can safely presume the parent is a ul
    //         var ul = element.parentElement;
    //         var items = ul.getElementsByTagName("li");

    //         for (var i = 0; i < items.length; i++) {
    //             if (element != items[i] && items[i].classList.contains("savedurlsselected")) {
    //                 items[i].classList.remove("savedurlsselected");
    //             }
    //         }
    //         element.classList.add("savedurlsselected");
    //     }
    // } // selectUrl

    clearFilePreview() {
      this.previewFile.type = "";
    }, // clearFilePreview

    async saveFileExtendedInfo(theFile) {
      var dbid = theFile._id;
      var url = this.buildRestUrl("/file/" + dbid);
      // requestUrl, even if not saved, must always be relative.
      if (theFile.requestUrl && theFile.requestUrl.startsWith(config.baseUrl)) {
        theFile.requestUrl = theFile.requestUrl.substring(
          config.baseUrl.length
        );
      }

      console.log("saveFileExtendedInfo", objectsUtil.plain(theFile));
      try {
        await fetchWrapper(url, {
          method: "PUT",
          data: theFile
        });

        for (let i = 0; i < this.filesArray.length; i++) {
          const f = this.filesArray[i];
          if (f.id === dbid) {
            f.file = theFile;
            break;
          }
        }
      } catch (error) {
        this.logError(error);
      }
    },

    async getFileExtendedInfo(theFile) {
      const dbid = typeof theFile === "string" ? theFile : theFile.id;
      return await comms
        .getFile(dbid)
        .then(response => {
          return response.data;
        })
        .catch(error => {
          this.logError(error);
          return undefined;
        });
    },

    async updateContentAfterUpload(dbid) {
      return this.getFileExtendedInfo(dbid)
        .then(file => {
          console.log("file updated", file);

          const parentProject = file.parentproject;

          let isSelected = false;
          this.filesArray
            .filter(f => f.id == dbid)
            .forEach(f => {
              f.isSent = true;
              isSelected = f.isSelected;
            });
          if (isSelected) {
            this.setupPreviewData(file);
          }

          const projectById = this.$store.getters["projects/projectById"];
          const prj = projectById(parentProject);
          if (prj !== undefined) {
            // we should count the files again because we do not know if the
            // current file was already sent or not.
            return this.countFiles(parentProject).then(numrecs => {
              this.updateProjectCount(prj, numrecs);
              return this.prjChange({
                id: parentProject,
                prj: prj
              });
            });
          } else {
            console.log("project " + parentProject + " has not been found");
          }
        })
        .catch(error => {
          this.logError(
            "Could not get the file information. " + error.toString()
          );
        });
    },

    async updatePreview(dbid) {
      // if we selected a file, we try to preview it
      // first load the file info from the database
      return this.getFileExtendedInfo(dbid)
        .then(file => {
          return this.setupPreviewData(file);
        })
        .catch(error => {
          this.logError(
            "Could not get the file information. " + error.toString()
          );
        });
    },

    setupPreviewData(file) {
      if (file.type == "img" || file.type == "pdf") {
        var url = this.buildRestUrl(file.requestUrl);

        // for larger images we cannot use the base64 image
        // url, so for now leave it unrotated.

        // var blob;

        // const self = this;
        // const reader = new FileReader();

        // reader.onload = (function() {
        //   return function(e) {
        //     //  aImg.src = e.target.result;
        //     self.getOrientation(blob, function(orientation) {
        //       self.resetOrientation(
        //         e.target.result,
        //         orientation,
        //         400,
        //         function(resetBase64Image) {
        //           self.previewFile.type = file.type;
        //           self.previewFile.imgsrc = resetBase64Image;
        //         }
        //       );
        //     });
        //   };
        // })();

        // let response = await fetchWrapper(url);
        // let data = await response.blob();
        // let metadata = {
        //   type: "image/jpeg"
        // };
        // blob = new File([data], "test.jpg", metadata);
        // reader.readAsDataURL(blob);

        const buildImageUrl = url => {
          const imagesConfig = config.images || {};
          let finalUrl = url;
          if (imagesConfig.maxWidth || imagesConfig.format) {
            finalUrl += "?";
            if (imagesConfig.maxWidth) {
              finalUrl += `width=${imagesConfig.maxWidth}`;
              if (imagesConfig.format) {
                finalUrl += "&";
              }
            }
            if (imagesConfig.format) {
              // safari on iphone does not support webp
              if (imagesConfig.format !== "webp" || this.canIUseWebP) {
                finalUrl += `format=${imagesConfig.format}`;
              }
            }
          }
          return finalUrl;
        };

        this.previewFile.type = file.type;
        this.previewFile.headline = file.headline;
        this.previewFile.lead = file.lead;
        this.previewFile.body = file.body;
        this.previewFile.imgsrc = buildImageUrl(url);
        this.previewFile.dest = file.dest;
        this.previewFile.contentId = file.contentId;
        this.previewFile.published = file.published;
      } else if (file.type == "url" || file.type == "any") {
        // console.log(JSON.stringify(file));
        this.previewFile.type = file.type;
        this.previewFile.headline = file.headline;
        this.previewFile.lead = file.lead;
        this.previewFile.body = file.body;
        this.previewFile.imgsrc = file.requestUrl;
        this.previewFile.dest = file.dest;
        this.previewFile.contentId = file.contentId;
        this.previewFile.published = file.published;
      } else {
        console.log("unsupported preview type", file);
        this.previewFile.type = "";
      }
      return this.previewFile;
    },

    onFileSelected(theFile) {
      if (
        theFile == undefined ||
        theFile.id == undefined ||
        !theFile.isSelected
      ) {
        this.clearFilePreview();
        return;
      }

      if (theFile.isSelected) {
        // if we selected a file, we try to preview it
        return this.updatePreview(theFile.id);
      }
    }, // onFileSelected

    onFileDragStart() {
      this.internalDragDrop = true;
    },
    onFileDragEnd() {
      this.internalDragDrop = false;
    },
    async onFileToolbarDrop(transferData, button) {
      this.internalDragDrop = false;
      // Trovare la partizione
      var file;
      var newArea = button.label;
      for (var i = 0; i < this.filesArray.length; i++) {
        file = this.filesArray[i];
        if (file.isSelected) {
          var fileData = await this.getFileExtendedInfo(file);
          fileData.area = newArea;
          this.saveFileExtendedInfo(fileData);
        }
      }
      // this.areaOnClick("area" + newArea);
      this.updateCurrentProjectCount();
      this.areaOnClick(this.currentArea);
    },

    clearConfigSelection() {
      this.configHistory = [];
      var chhtml = document.getElementById("confighistory");
      chhtml.innerHTML =
        '<option value="all">all</option><option value="current">current</option>';
    }, // clearConfigSelection

    logMsg(theMsg) {
      this.fullLog = theMsg + "<br/>" + this.fullLog;
      console.log(theMsg);
    }, // logMsg

    timedUserMessage(theMsg) {
      this.userMessage = theMsg;
      this.logMsg(theMsg);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.errorStatus = false;
        this.userMessage = this.defaultUserMessage;
      }, 8000);
    },

    logSuccess(theMsg) {
      this.errorStatus = false;
      this.timedUserMessage(theMsg);
    }, // logError

    logError(theMsg) {
      this.errorStatus = true;
      this.timedUserMessage(theMsg);
    }, // logError

    clearLog() {
      this.fullLog = "";
    }, // clearConfigSelection

    addConfigSelection(config) {
      var chhtml = document.getElementById("confighistory");
      if (this.configHistory[config] == undefined) {
        this.configHistory[config] = config;
        chhtml.innerHTML =
          chhtml.innerHTML +
          '<option value="' +
          config +
          '">' +
          config +
          "</option>";
      }
    }, // addConfigSelection

    // eslint-disable-next-line no-unused-vars
    handleDesktopDrop: function (e) {
      if (!this.$refs.edt.isEditing() && !this.internalDragDrop) {
        this.$refs.drp.hideDropper();
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleDragOver: function (e) {
      // this.$refs.drp.showDropper();
    },
    handleDragEnter: function (e) {
      // console.log("dragenter " + JSON.stringify(e));
      if (!this.$refs.edt.isEditing() && !this.internalDragDrop) {
        this.enterTarget = e.target;
        this.$refs.drp.showDropper();
      }
    },
    handleDragLeave: function (e) {
      // console.log("****dragleave");
      if (!this.$refs.edt.isEditing() && !this.internalDragDrop) {
        if (this.enterTarget == e.target) {
          this.$refs.drp.hideDropper();
        }
      }
    },
    addDropEvents(elementid) {
      var e = document.getElementById(elementid);
      ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
        e.addEventListener(eventName, this.preventDefaults, false);
      });
      ["dragenter", "dragover"].forEach(eventName => {
        e.addEventListener(eventName, this.highlight, false);
      });
      ["dragleave", "drop"].forEach(eventName => {
        e.addEventListener(eventName, this.unhighlight, false);
      });

      e.addEventListener("drop", this.handleDrop, false);
    }, // addDropEvents

    // from http://stackoverflow.com/a/32490603
    getOrientation(file, callback) {
      var reader = new FileReader();

      reader.onload = function (event) {
        var view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xffd8) return callback(-2);

        var length = view.byteLength,
          offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xffe1) {
            // eslint-disable-next-line
            if (view.getUint32((offset += 2), false) != 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16((offset += 6), false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++)
              if (view.getUint16(offset + i * 12, little) == 0x0112)
                return callback(view.getUint16(offset + i * 12 + 8, little));
          } else if ((marker & 0xff00) != 0xff00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
    }, // getOrientation

    resetOrientation(srcBase64, srcOrientation, imgmax, callback) {
      var img = new Image();

      img.onload = function () {
        var width = img.width,
          height = img.height,
          canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d");

        if (width >= height) {
          height = (imgmax / width) * height;
          width = imgmax;
        } else {
          width = (imgmax / height) * width;
          height = imgmax;
        }
        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        // draw image
        ctx.drawImage(img, 0, 0, width, height);

        // export base64
        callback(canvas.toDataURL());
      };

      img.src = srcBase64;
    },

    /**
     * addTxtToProject
     * @param {Object} file - Description of the text to add to the project
     */
    async addTxtToProject(theFile) {
      let url = this.buildRestUrl("/articletoproject");
      try {
        let reqdata = {
          file: theFile
        };
        if (theFile.dest === undefined) {
          theFile.dest = this.getProfileService().getDefaultDestination();
        }
        var response = await fetchWrapper(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          data: reqdata
        });
        var data = response.data;
        // when adding a file to the view we should have all the fields.
        const newFile = objectsUtil.plain(theFile);
        newFile._id = data._id;
        newFile.name = data.name;
        newFile.type = newFile.type || "url";
        this.addNewFile(newFile);
        this.clearDropPreview();
      } catch (error) {
        this.logError("Element could not be added. " + error.toString()); // Error. Inform the user
        this.clearDropPreview();
      }
    }, // addTxtToProject

    // eslint-disable-next-line no-unused-vars
    async addAnyToProject(file, theProject, theAreaName) {
      var extension = file.name.split(".").pop();

      let url = "";
      if (
        this.validExtensions.indexOf(extension) >= 0 &&
        theProject.options.wordToArticle
      ) {
        url = this.buildRestUrl("/wordtoproject");
      } else {
        url = this.buildRestUrl("/anytoproject");
      }
      this.$refs.drp.updateDroppedImg("/img/" + extension + ".png");
      var doclink = await this.uploadBinary(file);

      let anyData = new w2dAny(
        file.name,
        doclink,
        theProject._id,
        this.getAreaName(this.currentArea)
      );
      anyData.dest = theProject.dest
        ? theProject.dest
        : this.getProfileService().getDefaultDestination();

      try {
        var response = await fetchWrapper(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
            // "Content-Type": "application/x-www-form-urlencoded",
          },
          data: anyData
        });
        this.addNewFile(response.data);
      } catch (error) {
        this.logError("Can not add file to project. " + error.toString());
        console.error("addAnyToProject error", error);
      }
    }, // addAnyToProject

    pdfToText(data) {
      return pdfjsLib.getDocument(data).then(function (pdf) {
        // do stuff
        var pages = [];
        for (var i = 0; i < pdf.numPages; i++) {
          pages.push(i);
        }
        return Promise.all(
          pages.map(function (pageNumber) {
            return pdf.getPage(pageNumber + 1).then(function (page) {
              return page.getTextContent().then(function (textContent) {
                return textContent.items
                  .map(function (item) {
                    return item.str;
                  })
                  .join("");
              });
            });
          })
        ).then(function (pages) {
          return pages.join("\r\n");
        });
      });
    }, // pdfToText

    async pdfToImg(data) {
      var pdf = await pdfjsLib.getDocument(data);
      var firstimg = {};
      // do stuff
      // the pdf file is already in the dropper queue and the first page will be the first preview, so we need to add
      // numpages-1 number of new images to display
      this.$refs.drp.addFiles(pdf.numPages - 1);
      for (var i = 0; i < pdf.numPages; i++) {
        var page = await pdf.getPage(i + 1);
        // We render to a bigger size then displayed because it gives better quality
        // results if the final scaling is done by the browser
        var imgmax = 1320;
        var vp = page.getViewport(1);
        //
        // Prepare canvas using PDF page dimensions
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");

        var width = vp.width,
          height = vp.height;

        if (width >= height) {
          height = (imgmax / width) * height;
          width = imgmax;
        } else {
          width = (imgmax / height) * width;
          height = imgmax;
        }
        canvas.height = height;
        canvas.width = width;

        var scale = Math.min(
          canvas.width / vp.width,
          canvas.height / vp.height
        );
        var viewport = page.getViewport(scale);
        //
        // Render PDF page into canvas context
        //
        await page.render({
          canvasContext: context,
          viewport: viewport
        });
        var base64Image = canvas.toDataURL();
        this.$refs.drp.updateDroppedImg(base64Image);
        if (i == 0) {
          firstimg.img = document.createElement("img");
          firstimg.img.src = base64Image;
          firstimg.width = width;
          firstimg.height = height;
        }
      }
      return firstimg;
    }, // pdfToImg

    async uploadPdf(file, theProject, theAreaName) {
      var img, div;
      var tmpthis = this;

      const reader = new FileReader();
      // If I remove aImg and aDiv the inner function will not be called blimey
      // eslint-disable-next-line no-unused-vars
      reader.onload = (function (aImg, aDiv) {
        return async function (e) {
          //  aImg.src = e.target.result;
          // e.target.result
          //Step 4:turn array buffer into typed array
          var typedarray = new Uint8Array(e.target.result);

          var thumbnail = await tmpthis.pdfToImg(typedarray);
          var text = await tmpthis.pdfToText(typedarray);
          var doclink = await tmpthis.uploadBinary(file);

          var img = thumbnail.img;
          var canvas = document.createElement("canvas");
          canvas.width = thumbnail.width;
          canvas.height = thumbnail.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          var imglink = await tmpthis.uploadBinary(
            canvas.toDataURL("image/jpeg", 0.8)
          );
          const defaultDest = theProject.dest
            ? theProject.dest
            : tmpthis.getProfileService().getDefaultDestination();
          var newPdf = await comms.addPdfToProject(
            imglink,
            doclink,
            text,
            file.name,
            theProject._id,
            theAreaName,
            {
              dest: defaultDest
            }
          );
          newPdf.dest = defaultDest;
          tmpthis.addNewFile(newPdf);
        };
      })(img, div);
      reader.readAsArrayBuffer(file);
      //reader.readAsDataURL(file);
    }, // uploadPdf

    async uploadAny(file, theProject, theAreaName) {
      return this.addAnyToProject(file, theProject, theAreaName);
    }, // uploadAny

    /**
     * uploadTxt
     * @param {Object} file - File descriptors
     */
    async uploadTxt(file, theProject) {
      var extension = file.name.split(".").pop();
      this.$refs.drp.updateDroppedImg("/img/" + extension + ".png");
      var newTxt = new w2dArticle(
        "",
        this.getSelectedProject().id,
        this.getAreaName(this.currentArea)
      );

      newTxt.dest = theProject.dest
        ? theProject.dest
        : this.getProfileService().getDefaultDestination();

      var reader = new FileReader();

      // eslint-disable-next-line no-unused-vars
      reader.onload = e => {
        newTxt.name = file.name;
        newTxt.body = reader.result;
        this.addTxtToProject(newTxt);
      };
      reader.readAsText(file, "ISO-8859-1");
    },

    /**
     * uploadXML
     * Process an XML file and tries to interpret its contents.
     * While processing, package the different files referenced by the xml
     * @param {Object} file - File descriptors
     */
    async uploadXML(file, theProject) {
      var extension = file.name.split(".").pop();
      this.$refs.drp.updateDroppedImg("/img/" + extension + ".png");

      var tmpthis = this;
      var reader = new FileReader();

      // eslint-disable-next-line no-unused-vars
      reader.onload = async e => {
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(reader.result, "text/xml");
        var articles = xmlDoc.getElementsByTagName("article");
        var articlename = "";

        for (var i = 0; i < articles.length; i++) {
          var newArticle = new w2dArticle(
            "",
            tmpthis.getSelectedProject().id,
            tmpthis.getAreaName(tmpthis.currentArea)
          );
          articlename = "";
          // Found an article
          for (var j = 0; j < articles[i].childNodes.length; j++) {
            // Go through all the elements that define an article
            var el = articles[i].childNodes[j];
            var tagname = el.nodeName;
            if (tagname == "textName") {
              articlename = el.childNodes[0].nodeValue.split("\\").pop().trim();
              let referencedFile = await tmpthis.getFilebyName(articlename);
              if (referencedFile != undefined) {
                for (var k = 0; k < el.childNodes.length; k++) {
                  var el2 = el.childNodes[k];
                  if (el2.nodeName == "type") {
                    var type = el2.innerHTML;
                    // Now we have to find the article with name=articlename
                    // Read the contents of the article and put them in the right field
                    // delete the article
                    referencedFile = await comms.getFile(referencedFile.id);
                    if (type == "Headline") {
                      newArticle.headline = referencedFile.body;
                    } else if (type == "Text") {
                      newArticle.body = referencedFile.body;
                    } else if (type == "Caption") {
                      newArticle.caption = referencedFile.body;
                    }
                  }
                }
                tmpthis.deleteFile(referencedFile._id);
              }
            } else if (tagname == "imgName") {
              var imgname = el.childNodes[0].nodeValue.split("\\").pop().trim();
              let referencedFile = await tmpthis.getFilebyName(imgname);
              if (referencedFile) {
                referencedFile = await comms.getFile(referencedFile.id);
                newArticle.imglink = referencedFile.imglink;
              }
            }
          }

          // After we have collected all the information
          // we create a new article and add it to the list
          newArticle.name = newArticle.headline;
          if (!newArticle.name) {
            newArticle.name = "noname";
          }
          newArticle.dest = theProject.dest
            ? theProject.dest
            : this.getProfileService().getDefaultDestination();
          console.log(objectsUtil.plain(newArticle));
          tmpthis.addTxtToProject(newArticle);
        }
      };
      reader.readAsText(file, "ISO-8859-1");
    },

    async uploadBinary(file) {
      var url = this.buildRestUrl("/pictures");
      var formData = new FormData();
      var tmpthis = this;

      try {
        formData.append("file", file);
        var response = await fetchWrapper(url, {
          method: "POST",
          body: formData,
          "Content-Type": "application/x-www-form-urlencoded"
        });

        var data = await response.json();
        var imglink = data.imglink;
        // div.id = "thmb" +  imglink;
        return imglink;
      } catch (err) {
        tmpthis.logError("Could not upload file. " + err.toString());
        throw err;
      }
    }, // uploadBinary

    /**
     * Event called when a new img is uploaded by the CK Editor in the editor.vue component
     */
    async onNewImg(newImgData) {
      var project = this.getSelectedProject();
      if (project) {
        var projectid = project.id;
        var areaname = this.getAreaName(this.currentArea);
        let imgName = newImgData.srcFilename || newImgData.imglink;
        if (imgName.indexOf("/") > 0) {
          const idx = imgName.lastIndexOf("/");
          imgName = imgName.substring(idx + 1);
        }
        var newfile = await comms.addImgToProject(
          newImgData.imglink,
          imgName,
          projectid,
          areaname,
          {
            dest: this.getProfileService().getDefaultDestination()
          }
        );
        this.addNewFile(newfile);
      }
    },
    /**
     * uploadImg
     *
     * First uploads the picture binary file to the w2d server
     * After the file has been uploaded, an image record is created and added to the current project
     * Note: the upload operation just transfer the binary file to the server
     */
    async uploadImg(file, theProject, theAreaName) {
      let url = this.buildRestUrl("/pictures");
      let formData = new FormData();
      formData.append("file", file);
      const self = this;
      return fetchWrapper(url, {
        method: "POST",
        body: formData,
        useAxios: true, // use axios so we can use the onUploadProgress event.
        onUploadProgress: function (progressEvent) {
          console.log("progressEvent", progressEvent);
          self.$refs.drp.updateUploadProgress(
            progressEvent.loaded,
            progressEvent.total
          );
        }
      })
        .then(function (response) {
          if (file.type !== "image/heic") {
            const reader = new FileReader();
            reader.onload = (function () {
              return function (e) {
                //  aImg.src = e.target.result;
                self.getOrientation(file, function (orientation) {
                  self.resetOrientation(
                    e.target.result,
                    orientation,
                    632,
                    function (resetBase64Image) {
                      self.$refs.drp.updateDroppedImg(resetBase64Image);
                    }
                  );
                });
              };
            })();
            reader.readAsDataURL(file);
          } else {
            // heic images cannot be shown so we simply skip them.
            self.$refs.drp.updateDroppedImg("/img/img.png");
          }
          return response.data;
          // Done. Inform the user
        })
        .then(async function (data) {
          var imglink = data.imglink;
          // div.id = "thmb" +  imglink;

          const addImgOptions = {
            config: "default",
            dest: self.getProfileService().getDefaultDestination()
          };
          if (theProject.dest) {
            addImgOptions.dest = theProject.dest;
          }
          if (data.iptc) {
            addImgOptions.iptc = data.iptc;
          }
          if (data.mimetype) {
            addImgOptions.mimetype = data.mimetype;
          }

          var newfile = await comms.addImgToProject(
            imglink,
            file.name,
            theProject._id,
            theAreaName,
            addImgOptions
          );
          self.addNewFile(newfile);
        })
        .catch(err => {
          console.log(err);
          self.logError("Could not upload file. " + err.toString());
          self.$refs.drp.updateDroppedImg(null);
        });
    }, // uploadImg

    uploadLocalFile(file, theProject, theAreaName) {
      var images = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/webp",
        "image/heic"
      ];
      if (file.type == "application/pdf")
        return this.uploadPdf(file, theProject, theAreaName);
      else if (images.includes(file.type)) {
        return this.uploadImg(file, theProject, theAreaName);
      } else {
        // if it is not an image or a pdf than we should only allow
        // one article inside the project.
        let txtCount = this.currentUploadedTxtFiles;
        this.filesArray
          .filter(f => f && f.file && f.file.type === "url")
          .map(() => (txtCount += 1));
        if (txtCount > 0) {
          const msg = this.$t("message.tooManyArticles");
          this.logError(msg);
          // make sure we "decrease" the dropped counter.
          this.$refs.drp.updateDroppedImg(null);
          return;
        }
        this.currentUploadedTxtFiles += 1;
        const extension = file.name.split(".").pop();
        const isServerHandled = this.validExtensions.indexOf(extension) >= 0;
        if (file.type == "text/plain" && !isServerHandled) {
          return this.uploadTxt(file, theProject);
        } else if (file.type == "text/xml" && !isServerHandled) {
          return this.uploadXML(file, theProject);
        } else {
          return this.uploadAny(file, theProject, theAreaName);
        }
      }
    }, // uploadFile

    async handleDropURL(theUrl) {
      var project = this.getSelectedProject();
      this.$refs.drp.setFiles(1);
      this.$refs.drp.updateDroppedImg("/img/url.png");
      this.addUrlToProject(theUrl, project);
    }, // handleDropURL

    handleFiles(files) {
      //   var preview = document.getElementById("preview");
      //   preview.innerHTML = "";
      var project = this.getSelectedProject().project;
      var areaname = this.getAreaName(this.currentArea);

      this.$refs.drp.showDropper();
      this.$refs.drp.setFiles(files.length);

      this.currentUploadedTxtFiles = 0;
      for (var i = 0; i < files.length; i++) {
        this.uploadLocalFile(files[i], project, areaname);
      }
    }, // handleFile

    /**@function onDrop
     * Called by the dropper component through the emission of an event
     *
     */
    onDrop(eventInfo) {
      this.handleDrop(eventInfo);
    },

    /**@function onDropComplete
     * Called by the dropper component through the emission of an event
     * After the upload of dropped elements has ended
     *
     */
    // eslint-disable-next-line no-unused-vars
    onDropComplete(eventInfo) {
      this.updateCurrentProjectCount();
    },

    handleDrop(e) {
      if (this.getSelectedProject()) {
        this.$refs.files.clearSelection();
        let dt = e.dataTransfer;
        let files = dt.files;
        var url = dt.getData("text/uri-list");
        if (url != "") {
          this.handleDropURL(url);
        } else {
          this.handleFiles(files);
        }
      } else {
        this.logError(this.$t("message.selectProject"));
        this.$refs.drp.hideDropper();
      }
    },

    // eslint-disable-next-line no-unused-vars
    highlight(e) {
      var el = document.getElementById("dropfiles");
      el.classList.add("highlight");
    },

    // eslint-disable-next-line no-unused-vars
    unhighlight(e) {
      var el = document.getElementById("dropfiles");
      el.classList.remove("highlight");
    },

    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }, // preventDefaults

    // Add a new project, open the new project dialog
    addProjectBtnOnClick() {
      var project = this.getSelectedProject();
      if (project) {
        project.isSelected = false;
      }
      this.editProjectData = new Project(this.getUserName(), "");
      this.$refs.prjedt.editFile();
    }, // addProjectBtnOnClick

    /**
     *  Edit the current project configuration
     */
    editProjectBtnOnClick() {
      var projectRow = this.getSelectedProject();
      if (projectRow) {
        this.editProjectData = projectRow.project;
        this.$refs.prjedt.editFile();
      } else {
        this.logError(this.$t("message.selectProject"));
      }
    }, // editProjectBtnOnClick

    async onclickDeleteProject() {
      var project = this.getSelectedProject();
      if (!project) {
        this.logError(this.$t("message.selectProject"));
        return;
      }
      let url = this.buildRestUrl("/project/" + project.id);
      try {
        await fetchWrapper(url, {
          method: "DELETE"
        });
        return this.prjRemove(project.id);
      } catch (err) {
        this.logError("Could not delete project. " + err.toString()); // Error. Inform the user
      }
    },

    async onclickUploadProject() {
      var selectedConfig = this.getSelectedConfig();
      var selectedProject = this.getSelectedProject();

      if (!selectedProject) {
        this.logError(this.$t("message.selectProject"));
        return;
      }

      if (!selectedConfig) {
        this.logError(this.$t("message.selectConfiguration"));
        return;
      }

      if (!this.isOnline()) {
        this.logError(this.$t("message.userOffline"));
        return;
      }

      const skipFiles = [];
      for (var i = 0; i < this.filesArray.length; i++) {
        const file = this.filesArray[i];
        file.isError = undefined;
        const validation = this.validateBeforeSend(file);
        if (!validation.validated) {
          this.emiValidationFailed(file, validation);
          skipFiles.push(file.id);
        }
      }

      if (skipFiles.length > 0) {
        return;
      }

      this.logSuccess("Uploading " + selectedProject.name);
      let data = {
        project: selectedProject.id,
        config: selectedConfig.id,
        socketid: this.socketId,
        ...this.getApiClientProfileOptions(),
        skipFiles
      };
      return this.apiClient
        .uploadProject(data)
        .then(r => {
          this.logSuccess("Upload in progress...", r);
          if (r.jwt !== undefined) {
            // jwt token has been refreshed, update the store.
            this.setToken(r.jwt);
          }
        })
        .catch(err => {
          this.logError("Upload failed: " + err.toString());
          this.processApiResponseError(err);
        });
    },

    async uploadFile(theConfig, theFileId) {
      if (!theConfig) {
        throw new Error("Missing configuration");
      }
      if (!theFileId) {
        throw new Error("Missing file");
      }
      this.logSuccess("Uploading " + theFileId);
      let data = {
        file: theFileId,
        config: theConfig.id,
        socketid: this.socketId,
        ...this.getApiClientProfileOptions()
      };
      return this.apiClient
        .uploadFile(data)
        .then(r => {
          this.logSuccess("Upload in progress...", r);
          if (r.jwt !== undefined) {
            // jwt token has been refreshed, update the store.
            this.setToken(r.jwt);
          }
        })
        .catch(err => {
          this.logError("Upload failed: " + err.toString());
          this.processApiResponseError(err);
        });
    },

    processApiResponseError(err) {
      if (err.response) {
        if (err.response.status === 401 && err.response.data) {
          const errorData = err.response.data;
          console.log(errorData);
          if (errorData && errorData.errorText === "invalid jwt token") {
            window.alert(this.$t("message.jwtExpired"));
            this.logout();
          } else if (errorData === "Unauthorized") {
            window.alert(this.$t("message.tokenExpired"));
            this.logout();
          }
        } else if (err.response.status === 500 && err.response.data) {
          const errorData = err.response.data;
          console.log(errorData);
          const remoteError = errorData.error || {};
          if (
            remoteError.errno === "ECONNREFUSED" ||
            remoteError.errno === "ENOTFOUND"
          ) {
            const errorMsg = this.$t("login.ERR_REMOTE_UNREACHABLE");
            this.logError(errorMsg);
          }
        }
      }
    },

    getApiClientProfileOptions() {
      const profileSvc = this.getProfileService();
      return {
        destinations: profileSvc.getDestinations(),
        contentTypes: profileSvc.getContentTypes(),
        fixedFields: profileSvc.getFixedFields(),
        userFields: profileSvc.getUserFields()
      };
    },

    async onclickUploadNewFile() {
      let input = document.getElementById("UploadButton");
      if (input) {
        // sometimes the onchange function for an already existing upload button
        // is not called, so if it does already exists than we will remove it
        // and re-create it.
        input.remove();
        input = undefined;
      }
      if (!input) {
        input = document.createElement("input");
        var divattach = document.getElementById("utility");
        if (divattach) {
          divattach.appendChild(input);
        }
        if (input) {
          input.setAttribute("id", "UploadButton");
          input.type = "file";
          input.multiple = true;
          input.accept =
            this.validExtensions.map(e => "." + e).join(", ") +
            ", .pptx, .pdf, image/*";
          input.onchange = e => {
            this.handleFiles(e.target.files);
          };
        }
      }
      if (input) {
        input.click();
      } else {
        this.logError("Internal: could not create the input button");
      }
    },

    async onclickUploadSelected() {
      var selectedConfig = this.getSelectedConfig();

      if (!selectedConfig) {
        this.logError(this.$t("message.selectConfiguration"));
        return;
      }

      if (!this.isOnline()) {
        this.logError(this.$t("message.userOffline"));
        return;
      }

      try {
        const ids = [];
        const names = {};
        for (let i = 0; i < this.filesArray.length; i++) {
          const theFile = this.filesArray[i];
          if (theFile.isSelected) {
            theFile.isError = undefined;
            const validationResult = this.validateBeforeSend(theFile);
            if (validationResult.validated) {
              const id = theFile.id;
              ids.push(id);
              names[id] = theFile.name;
            } else {
              this.emiValidationFailed(theFile, validationResult);
            }
          }
        }

        const promises = [];
        for (let i = 0; i < ids.length; i++) {
          const id = ids[i];
          this.logSuccess("Uploading " + names[id]);
          const p = this.uploadFile(selectedConfig, id).then(() => {
            this.filesArray
              .filter(f => f.id == id)
              .forEach(f => (f.isSent = true));
            if (i == 0) {
              this.getFileExtendedInfo(id).then(file => {
                this.setupPreviewData(file);
              });
            }
          });
          promises.push(p);
        }
        for (let idx = 0; idx < promises.length; idx++) {
          await promises[idx];
        }
      } catch (err) {
        this.logError("Upload failed: " + err.toString());
      }
    }, // onclickUploadSelected

    validateBeforeSend(theFile) {
      const result = {
        validated: theFile.file.body && theFile.file.body.trim().length > 0
      };
      if (!result.validated) {
        result.msg = this.$t("validation.error", {
          field: this.$t("editor.FIELD_BODY")
        });
      }
      return result;
    }, // validateBeforeSend

    emiValidationFailed(theFile, validationResult) {
      const errorMsg = this.$t("validation.failed", {
        name: theFile.name,
        msg: validationResult.msg
      });
      this.logError(errorMsg);
      theFile.isError = errorMsg;
    }, // emiValidationFailed

    async createProject(theProject) {
      let url = this.buildRestUrl("/project/" + theProject.name);
      try {
        var response = await fetchWrapper(url, {
          method: "POST",
          data: theProject
        });
        var jsonData = response.data;
        var newprj = new ProjectRow(jsonData, this.prjSelect);
        this.prjAdd(newprj).then(() => {
          this.selectProject(newprj);
        });
      } catch (err) {
        this.logError("Could not add project. " + err.toString()); // Error. Inform the user
      }
    }, // createProject

    /** Store changes to a project definition into the database */
    async saveProject(theProject) {
      const url = this.buildRestUrl("/project/" + theProject._id);
      try {
        await fetchWrapper(url, {
          method: "PUT",
          data: theProject
        });

        // get the updated files count
        var updPrj = new ProjectRow(theProject, this.prjSelect);
        const numrecs = await this.countFiles(updPrj.id);
        this.updateProjectCount(updPrj, numrecs);

        // update model
        return this.prjChange({ id: updPrj.id, prj: updPrj });
      } catch (err) {
        this.logError("Could not update project. " + err.toString()); // Error. Inform the user
      }
    },

    getProfileService() {
      return new profileService({
        profile: this.profile,
        user: this.user
      });
    },

    isOnline() {
      return this.user && this.user.online;
    },

    isOnlineMsg() {
      return this.$t(
        this.isOnline() ? "message.userOnline" : "message.userOffline"
      );
    },

    showLogMsg() {
      return this.$t(this.showLog ? "menu.HIDE_LOG" : "menu.SHOW_LOG");
    }

    // OK button pressed on the dialog that ask for a new project name
    /*projectNameDialogConfirmBtnClick() {
      var text = document.getElementById("newprojectname");
      var newprjname = text.value;
      if (newprjname != "") {
        this.favDialog.close();
        this.createProject(thos.getUserName(), newprjname);
      } else {
        this.logError("Please enter a project name");
      }
    } // projectNameDialogConfirmBtnClick*/
  },
  mounted: function () {
    this.user = this.$store.getters.user;
    this.profile = this.$store.getters.profile;
    this.socket = serverConnect;
    this.apiClient = new apiClient({
      $http: this.$http,
      jwt: this.$store.getters.token
    });
    this.client = this.currentArea = this.getAreaId("Incoming");
    console.log("window.onload");
    this.showLog = this.getCookie("showLog") == "true";

    this.canIUseWebP = (() => {
      var elem = document.createElement("canvas");

      if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
      }

      // very old browser like IE 8, canvas not supported
      return false;
    })();
    console.log("can I use webp?", this.canIUseWebP);

    this.reloadConfig();
    this.reloadProjects();
    // socket.emit('getstats', { my: 'data', url: window.location.href });

    //this.addDropEvents("dropfiles");

    // Event generated by the CK Editor when a new image is added
    eventBus.$on("onNewImg", newImgData => {
      this.onNewImg(newImgData);
    });

    // The client is connected to the server, a unique id is given by the server to the client, that can be used to
    // uniquely identify the client during other transactions. For example during a rest call the client can provide the id
    // that the server will use to send back progress updates
    this.socket.on("welcome", data => {
      this.logSuccess(data.msg + " " + data.text);
    });

    this.socket.on("news", data => {
      console.log(data);
      this.logSuccess(data.msg + " " + data.text);
    });
    this.socket.on("failure", data => {
      console.log(data);
      this.logError(data.msg + " " + data.text);
    });
    this.socket.on("reloadProjects", data => {
      const projectsIds = JSON.parse(data.text);
      console.log("projects purged", projectsIds);
      let reload = false;
      for (let idx = 0; idx < projectsIds.length; idx++) {
        const id = projectsIds[idx];
        if (this.getProjectById(id)) {
          reload = true;
          break;
        }
      }
      if (reload) {
        this.logSuccess(
          "Some projects have been purged, reloading the projects list"
        );
        this.reloadProjects();
      }
    });

    // not interested in the aborted files.
    //eventBus.$on("socket:fileUploadAborted", data => {
    //  console.log("upload aborted for ", data);
    //});

    // listed to upload complete events and update file count and status
    eventBus.$on("socket:fileUploadCompleted", data => {
      //console.log("fileUploadCompleted", data);
      this.updateContentAfterUpload(data.id);
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* Style the navigation menu */
.topnav {
  overflow: hidden;
  background-color: #28567e;
  position: relative;
}

/* Hide the links inside the navigation menu (except for logo/home) */
.topnav #menuEntries {
  display: block;
}

/* Style navigation menu links */
.topnav a {
  color: white;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
  display: block;
}

/* Style the hamburger menu */
.topnav a.icon {
  background: #28567e;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
}

.topnav a.icon.online {
  right: 50px;
}

.topnav a.icon.offline {
  color: #828d98;
  right: 50px;
}

/* Add a grey background color on mouse-over */
.topnav a:hover {
  background-color: #ddd;
  color: #28567e;
}

/* Style the active link (or home/logo) */
.active {
  background-color: #ddd;
  color: white;
}

a.applogo:hover {
  background-color: #28567e;
  color: white;
}
a.success {
  color: blue;
}

a.error {
  color: red;
}

.v--modal-block-scroll {
  overflow: hidden;
  width: initial;
}
html,
body {
  margin: 0px;
  height: 100%;
}

body {
  font-weight: 300;
  word-break: normal;
  font-family: "Open Sans", Arial;
  color: #28567e;
}

body.popup {
  overflow: hidden;
}

#app {
  height: 100%;
}

div.vapp {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
}
.apphead {
  padding-top: 0em;
  padding-bottom: 0em;
  padding-left: 0em;
  padding-right: 0em;
  background-color: #28567e;
  overflow: visible;
}

.appbody {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding-top: 1em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  background-color: #f0f0f0;
  box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.05),
    inset 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
  overflow: auto;
}

.appbodyheader {
  flex: 0 0 4em;
}

.appbodytoolbar,
.largetoolbar {
  flex: 0 0 2em;
  overflow: hidden;
}

.appbodybody {
  flex: 1 1 auto;
}

.appbodybodywrapper {
  height: 100%;
}

.apptail {
  padding-top: 1em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  background-color: #f0f0f0;
  flex: 0 0 14em;
  display: flex;
  flex-direction: column;
}
h1 {
  font-size: 1.6em;
  font-weight: 700;
  margin: 0;
}

h1.applogo {
  background-color: #28567e;
  color: white;
  padding: 14px 16px;
}

h2 {
  font-size: 1em;
  font-weight: 500;
  margin: 0;
  /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}
.standardtext {
  font-size: 14px;
  font-weight: 500;
  /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
}

input {
  font-size: 1em;
  font-weight: 500;
  /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
}

div.log {
  font-size: 0.8em;
  color: #28567e;
  font-weight: 500;
  min-height: calc(100% - 3em);
  max-height: calc(100% - 3em);
}

div.connections {
  font-size: 10px;
  color: #28567e;
  font-weight: 500;
  white-space: nowrap;
  overflow: auto;
  border-style: none;
  border-color: #28567e;
  /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
}

.bluerectcontainer {
  /* Leave padding so the bluerect shadow can show */
  padding-right: 3px;
  padding-bottom: 3px;
  display: flex;
  flex-direction: column;
}
.bluerect,
.bluerectdialog {
  white-space: nowrap;
  overflow: auto;
  /*border-style: solid;
    border-color:#28567e;*/
  padding-left: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  position: relative;
  background: #fff;
  box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.15),
    0px 2px 3px 0px rgba(0, 0, 0, 0.1);
  padding: 4px;
  min-height: calc(100% - 2em);
  max-height: calc(100% - 2em);
  height: calc(100% - 2em);
}

.bluerect {
  margin-left: 1px;
  margin-right: 1px;
}

.bluerectdialog {
  padding: 20px;
}

.highlight {
  border-style: dashed;
}

table.cfg {
  width: 100%;
  border-collapse: collapse;
}

tr.cfg {
  width: 300px;
  padding-left: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 14px;
  color: #28567e;
  background-color: white;
  font-weight: 500;
  /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
  list-style-type: none;
  cursor: default;
}

tr.cfgselected {
  width: 300px;
  padding-left: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 14px;
  color: white;
  background-color: #28567e;
  font-weight: 500;
  /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
  list-style-type: none;
  cursor: default;
}

tr.cfgsent {
  color: #50a824;
}

tr.cfgselected.cfgsent {
  color: #e5e619;
}

tr.draggable {
  cursor: pointer;
}
td.cfg {
  padding-left: 6px;
  padding-right: 6px;
}

li.savedurls,
li.savedurlsselected,
li.projects,
li.projectsselected {
  padding-left: 2px;
  padding-top: 1px;
  padding-bottom: 1px;
  font-size: 14px;
  color: #28567e;
  font-weight: 300;
  /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif; */
  list-style-type: none;
  cursor: pointer;
}

li.cfgselected,
li.savedurlsselected,
li.projectsselected {
  color: white;
  background-color: #28567e;
}

div.url {
  flex: 0 0 66%;
  overflow: hidden;
  display: inline-flex;
  padding-left: 2px;
}

div.config {
  flex: 0 0 14%;
  overflow: hidden;
  display: inline-flex;
  padding-left: 4px;
}

div.datetime {
  flex: 1;
  overflow: hidden;
  display: inline-flex;
  padding-left: 4px;
}

hr {
  border-color: #28567e;
}

.centeringparent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.droponmeparent {
  display: flex;
  justify-content: center;
  align-items: center;
}
.droponmelabel {
  position: absolute;
  left: 20px;
  top: 20px;
}
.droponme {
  box-sizing: border-box;
  border: 4px dashed #ccc;
  border-radius: 20px;
  width: 98%;
  height: 98%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.droponme.highlight {
  border-color: #28567e;
}

p {
  margin-top: 0;
}

.my-form {
  margin-bottom: 10px;
}

#gallery {
  margin-top: 10px;
}
#gallery img {
  width: 150px;
  margin-bottom: 10px;
  margin-right: 10px;
  vertical-align: middle;
}
.selectbutton {
  display: inline-block;
  padding: 10px;
  background: aliceblue;
  border-radius: 5px;
  border: 1px solid aliceblue;
  position: absolute;
  right: 0;
  bottom: 2;
}
.selectbutton:hover {
  background: #ddd;
}
#fileElem {
  display: none;
}

div.thumbnail {
  width: 140px;
  height: 140px;
  min-width: 140px;
  min-height: 140px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  border: #637aad;
  border-style: solid;
  border-width: 2px;
}
img.thumbnail {
  max-width: 140px;
  max-height: 140px;
}
img.thumbnailpreview {
  max-width: 90%;
  max-height: 90%;
}

.hwrapper {
  display: flex;
  flex-direction: row;
}

.wrapper {
  display: flex;
}

.wrapperbetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wrapped {
  flex: 0 0 auto;
  white-space: nowrap;
}

#errorarea {
  font-size: 20px;
  height: 10px;
}
.quickbutton,
.quicktextbutton {
  /*text-align: center;
    border: 0px;
    margin-left: 2px;
    margin-right: 2px;
    padding-left: 4px;
    padding-right: 4px;
    height: 24px;
    font-size: 16px;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: auto;
    border-style: none;
    border-radius: 5px;
    color:#28567e;
    background-color: aliceblue;
    box-shadow: inset 0px 0px 0px 0px rgba(0, 0, 0, 0.15), 0px 2px 2px 0px rgba(0, 0, 0, 0.1);*/
  display: inline-block;
  margin-left: 2px;
  margin-right: 2px;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 0.2em;
  box-sizing: border-box;
  text-decoration: none;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: #ffffff;
  background-color: #28567e;
  box-shadow: inset 0 -0.6em 1em -0.35em rgba(0, 0, 0, 0.17),
    inset 0 0.6em 2em -0.3em rgba(255, 255, 255, 0.15),
    inset 0 0 0em 0.05em rgba(255, 255, 255, 0.12);
  text-align: center;
  position: relative;
  outline: none;
}

.quickbutton:hover,
.quicktextbutton:hover {
  background-color: gainsboro;
}
.quicktextbuttonselected {
  background-color: gainsboro;
  box-shadow: inset 0 0.6em 2em -0.3em rgba(0, 0, 0, 0.15),
    inset 0 0 0em 0.05em rgba(255, 255, 255, 0.12);
}

.quickbuttondrop {
  background-color: darkgray;
}

.quickbutton {
  width: 24px;
}

div.inlinebutton {
  display: inline-block;
}

.configscontainer {
  flex: 0 0 18%;
}
.projectscontainer {
  flex: 0 0 18%;
}

.filescontainer {
  flex: 0 0 40%;
}

.historycontainer {
  flex: 0 0 60%;
}

.filepreviewcontainer {
  flex: 1;
}

#dropfilescontainer {
  flex: 1;
}

* {
  overflow: auto;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  h1 {
    font-size: 1em;
    font-weight: 700;
    margin: 0;
  }
  h2 {
    font-size: 0.8em;
    font-weight: 700;
    margin: 0;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
  }
  html,
  body {
    height: auto;
  }
  .configscontainer,
  .projectscontainer {
    height: 6em;
  }
  .filescontainer {
    height: 16em;
  }
  .filepreviewcontainer {
    height: 14em;
  }
  .apptail {
    height: 12em;
  }
}

div.mytooltip {
  text-align: left;
}
div.mytooltip ul {
  margin-left: -40px;
}

@media (max-width: 420px) {
  .largetoolbar {
    flex: 0 0 4em;
    overflow: hidden;
  }
}
</style>
